import { useState } from "react";

const SelectionActionButton = ({selectedAction, setSelectedAction, options, selectedRow, handleSelectionAction }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    // const [selectedAction, setSelectedAction] = useState("Select Action");

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
    const closeDropdown = () => setDropdownOpen(false);

    const handleSelect = (actionLabel) => {
        setSelectedAction(actionLabel);
        handleSelectionAction('multipleSelection',actionLabel);
        closeDropdown();
    };

    return (
        options.selectionAction && options.selectableRows && (
            Array.isArray(options.selectionAction) && selectedRow && selectedRow.length > 0  ? (
                <div className="relative inline-block">
                    <button
                        onClick={toggleDropdown}
                        className="bg-blue px-[12px] h-[30px] !text-white rounded-7 text-size-14 font-medium"
                    >
                        {selectedAction}
                    </button>

                    {dropdownOpen && (
                        <div className="absolute mt-1 bg-white shadow-md rounded-md z-10 overflow-hidden">
                            <ul className="">
                                {options.selectionAction.map((actionLabel, index) => (
                                    <li
                                        key={index}
                                        className={`px-4 py-2 hover:bg-gray-100 cursor-pointer text-size-13  ${
                                            selectedAction === actionLabel ? "bg-gray-100 font-semibold" : ""
                                        }`}
                                        onClick={() => handleSelect(actionLabel)}
                                    >
                                        {actionLabel}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            ) : typeof options.selectionAction === "string" && selectedRow && selectedRow.length > 0 ? (
                <button
                    onClick={() => handleSelectionAction('multipleSelection')}
                    className="bg-blue px-[12px] h-[30px] !text-white rounded-7 text-size-13 font-medium"
                >
                    {options.selectionAction}
                </button>
            ) : (
                <button
                    disabled
                    style={{ backgroundColor: "#a9a9a975", color: "#00000" }}
                    className="px-[12px] h-[30px] rounded-7 text-size-14 font-medium"
                >
                    {typeof options.selectionAction === "string"
                        ? options.selectionAction
                        : "Select Action"}
                </button>
            )
        )
    );
};

export default SelectionActionButton;
